import React, { useState, useEffect } from 'react';
import Sidebar from '../components/Sidebar';
import Footer from '../components/footer';

const Mc_best_paper = () => {
    const [isMobile, setIsMobile] = useState(false);
    const [sidebarExpanded, setSidebarExpanded] = useState(true);

    // 偵測螢幕大小
    useEffect(() => {
        const checkScreenSize = () => {
            const width = window.innerWidth;
            setIsMobile(width <= 768);
        };

        // 初始檢查
        checkScreenSize();

        // 監聽視窗大小變化
        window.addEventListener('resize', checkScreenSize);
        
        // 清理事件監聽器
        return () => window.removeEventListener('resize', checkScreenSize);
    }, []);

    // 監聽 sidebar 狀態變化的函數
    const handleSidebarToggle = (isExpanded) => {
        setSidebarExpanded(isExpanded);
    };

    return (
        <div style={{ display: 'flex', position: 'relative' }}>
            <Sidebar onToggle={handleSidebarToggle} />
            <div 
                className="main-content"
                style={{
                    marginLeft: isMobile ? '0' : (sidebarExpanded ? '250px' : '0')
                }}
            >
                <div className="container">
                    <header 
                            className="header"
                        >
                        <h1 className="title">MC 最佳論文</h1>
                    </header>
                    <section className={`section ${isMobile ? 'section-mobile' : ''}`}>
                        <h2 className="subtitle">最佳論文候選名單</h2>
                        <ul className="list">
                            <li className={`list-item ${isMobile ? 'list-item-mobile' : ''}`}>1. MC-08: 結合AI影像辨識與物聯網技術之草莓炭疽病檢測系統</li>
                            <li className={`list-item ${isMobile ? 'list-item-mobile' : ''}`}>2. MC-12: Anomaly Detection System for Smartphone Charging Based on Machine Learning and IoT Sensors</li>
                            <li className={`list-item ${isMobile ? 'list-item-mobile' : ''}`}>3. MC-81: 非正交多重存取網路下基於TD3之eMBB與URLLC服務共存資源配置機制</li>
                            <li className={`list-item ${isMobile ? 'list-item-mobile' : ''}`}>4. MC-43: 多平面語意注意力融合與多頭空間圖卷積網路於3D人體動作預測</li>
                            <li className={`list-item ${isMobile ? 'list-item-mobile' : ''}`}>5. MC-69: 不平坦地形中地面移動設備的網絡覆蓋增強：無人機協同通信策略</li>
                            <li className={`list-item ${isMobile ? 'list-item-mobile' : ''}`}>6. MC-17: CDRL: Catfish-Based Deep Reinforcement Learning for Energy-Efficient Joint Switching of RF Chains and Reflecting Elements in RIS-Aided 6G Networks</li>
                            <li className={`list-item ${isMobile ? 'list-item-mobile' : ''}`}>7. MC-76: 於自適應分群感測網中透過多充電器繞路協作延長節點壽命</li>

                        </ul>
                    </section>
                    <section className={`section ${isMobile ? 'section-mobile' : ''}`}>
                        <h2 className="subtitle">最佳學生論文候選名單</h2>
                        <ul className="list">
                            <li className={`list-item ${isMobile ? 'list-item-mobile' : ''}`}>1. MC-68: 以優先佇列改善零信任工業物聯網系統效率</li>
                            <li className={`list-item ${isMobile ? 'list-item-mobile' : ''}`}>2. MC-72: 對抗樣本技術應用於社交媒體之影像隱私保護研究與平台開發</li>
                            <li className={`list-item ${isMobile ? 'list-item-mobile' : ''}`}>3. MC-67: 基於深度強化學習之工業物聯網服務功能鏈最佳化配置</li>
                            <li className={`list-item ${isMobile ? 'list-item-mobile' : ''}`}>4. MC-79: 即時多攝影機行人行為理解與搜尋系統</li>
                            <li className={`list-item ${isMobile ? 'list-item-mobile' : ''}`}>5. MC-04: 應用於定時器檢查點的間歇式系統資料壓縮方法</li>
                            <li className={`list-item ${isMobile ? 'list-item-mobile' : ''}`}>6. MC-20: 邊緣韌性服務代理：基於邊緣 AI 建構 5G-NR與Wi-Fi 6 異質MEC網路IoT應用框架</li>
                            <li className={`list-item ${isMobile ? 'list-item-mobile' : ''}`}>7. MC-60: 雙層強化學習架構於無人機回程網路多類型服務切片資源最佳化</li>
                            <li className={`list-item ${isMobile ? 'list-item-mobile' : ''}`}>8. MC-59: 空地一體化異質網路下D2D通訊之能源效率與公平性聯合優化</li>
                        </ul>
                    </section>
                    <Footer/>
                </div>
            </div>
        </div>
    );
};

export default Mc_best_paper;